<!-- @format -->
<div *transloco="let t" [class]="'container sis-pt-md'">
  <sis-breadcrumbs />
  <sis-page-title [title]="t('APPLICATION_TIMING')" [showCrumbs]="true" />
  <fudis-grid [classes]="showSurvey ? 'timing-top-grid-with-notification' : ''" [columns]="1" [width]="'xl'">
    <fudis-body-text [variant]="'lg-light'">
      {{ t("TIMELINE.TIMING_GUIDANCE") }}
    </fudis-body-text>
    @if (showSurvey) {
      <fudis-notification [variant]="'info'">
        <fudis-body-text>
          {{ t("TIMELINE.SURVEY.INFO") }}
          <a fudisLink [href]="surveyUrl" [title]="t('TIMELINE.SURVEY.LINK_TEXT')" [external]="true" [size]="'md'"></a>
        </fudis-body-text>
      </fudis-notification>
    }
  </fudis-grid>

  @let plans = plans$ | async;
  @if (plans) {
    @if (plans.length > 0) {
      <div [class]="'timing-plan-select-background'">
        <fudis-grid [columns]="1" [width]="'initial'" [rowGap]="'xs'">
          <app-timing-plan-select />
          <app-total-credits />
        </fudis-grid>
      </div>
      <!-- Assuming that the page title has heading level 1 -->
      <app-timeline [headingLevel]="2" />
    } @else {
      <fudis-notification [variant]="'warning'">
        <fudis-body-text>{{ t("TIMELINE.NO_PLANS_NOTIFICATION") }}</fudis-body-text>
      </fudis-notification>
    }
  }
</div>
